export default {
  index() {
    return {
      endpoint: `/api/v1/entitlement_targets`,
      method: "GET"
    };
  }
};
